import React, {useEffect, useState} from 'react';

const DoorIcon = () => {
  const sizeMultiplier = 1;
  const width = 100 * sizeMultiplier;
  const height = 10 * sizeMultiplier;
  const half = width / 2;
  const doorHalfWidth = half - 1;

  return (
    <svg className="door-icon" width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <g>
        <title>Layer 1</title>
        <rect id="svg_3" height={"100%"} width={"50%"} y="0" x="0" stroke="#000" fill="currentColor" strokeWidth="4"/>
        <rect id="svg_4" height={"100%"} width={"50%"} y="0" x={"50%"} stroke="#000" fill="currentColor" strokeWidth="4"/>
      </g>
    </svg>
  )
}

const Door = ({className, ordinal, openModal}) => {
  return (
    <button className={"door " + className} onClick={openModal}>
      <DoorIcon/>
      <span className="door-text">DOOR-{ordinal}</span>
    </button>
  )
}

export const Doors = ({carNumber, ConditionService, $uibModal}) => {
  const [doors, setDoors] = useState([]);

  async function fetchData() {
    const assetFilter = {
      assetType: 'DOOR-CONTROLLER'
    };
    const response = await fetch('/service/condition/latest/cars?carIds=' + carNumber,
      {method: 'POST', body: JSON.stringify(assetFilter), headers: {"Content-Type": "application/json",}});
    return await response.json();
  }

  const loadDoors = async () => {
    const doorData = await fetchData();
    doorData.forEach(car => {
      car.bogies.forEach(door => { // Returned data model currently uses bogies for root asset
        door.categories.forEach(category => {
          category.assets.forEach(asset => {
            if (asset.ci_values != null) {
              asset.ci_values.map(ci => {
                ci.latestValue = _.last(ci.results).value;
              });
            }
          });
        });
      });
    });
    setDoors(doorData[0].bogies);
  };

  useEffect(() => {
    loadDoors();
  }, []);

  const doorOrientation = (door) => {
    let classNames = "";
    if (door.ordinal > 3) {
      classNames = 'door-bottom ';
    } else {
      classNames = 'door-up ';
    }
    classNames += door.status.toLowerCase();
    return classNames;
  }

  const openSubsystemModal = (door) => () => {
    const subSystemObject = {
      name: 'DOORS',
      cis: door.ci_values,
      assets: [door],
      carNumber,
    };
    const modalInstance = $uibModal.open({
      component: 'subsystemModal',
      windowClass: 'subSystemWindow',
      resolve: {
        subSystemObject: function () {
          return subSystemObject;
        },
      },
    });

    modalInstance.result.then(() => {
    }, () => {
    });
  };

  if (!doors.length) {
    return <></>
  }
  return (
    <div className={"doors"}>
      {doors[0].categories[0].assets.map(door =>
        <Door key={"door-" + door.ordinal}
              ordinal={door.ordinal}
              className={doorOrientation(door)}
              openModal={openSubsystemModal(door)}/>
      )}
    </div>
  )
}